module.exports = __webpack_public_path__ + "static/media/user_result_icon_grey.492da802.svg";